import clsx from 'clsx';
import { Notifications } from '@_/components';
import { useAppShell } from '#src/components/AppShell/useAppShell.ts';
import { MAX_PAGE_WIDTH } from '#src/theme/constants.ts';
import { AppFooter } from './AppFooter.tsx';
import { AppHeader } from './AppHeader/index.ts';

export function AppShell({
  children,
  grayBg = false,
  showHeaderSearch = true,
  simpleFooter = false,
  simpleHeader = false,
  stickyHeader = true
}: {
  children: React.ReactNode;
  grayBg?: boolean;
  showHeaderSearch?: boolean;
  simpleFooter?: boolean;
  simpleHeader?: boolean;
  stickyHeader?: boolean;
}) {
  const { appShellBounds } = useAppShell();

  return (
    <>
      <div className={clsx('flex min-h-screen flex-col', grayBg ? 'bg-gray-50' : 'bg-white')}>
        <AppHeader showSearch={showHeaderSearch} simple={simpleHeader} sticky={stickyHeader} />
        <main className="grow">{children}</main>
        <AppFooter dark={!simpleFooter} simple={simpleFooter} />
      </div>
      <Notifications className={MAX_PAGE_WIDTH} bounds={appShellBounds} />
    </>
  );
}
